import { Direction, Tabs as TabsPrimitive } from "radix-ui";
import * as React from "react";

import { useLanguage } from "@/contexts/language";
import { cn } from "@/lib/utils";

function Tabs({
  className,
  dir,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  const { dir: langDir } = useLanguage();
  const resolvedDir = dir ?? langDir;

  return (
    <Direction.Provider dir={resolvedDir}>
      <TabsPrimitive.Root
        data-slot="tabs"
        dir={resolvedDir}
        className={cn("tw:flex tw:flex-col tw:gap-3", className)}
        {...props}
      />
    </Direction.Provider>
  );
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "tw:inline-flex tw:h-11 tw:w-fit tw:items-center tw:justify-center tw:rounded-lg tw:bg-muted tw:p-1 tw:text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "tw:inline-flex tw:h-full tw:flex-1 tw:items-center tw:justify-center tw:gap-1.5 tw:whitespace-nowrap tw:rounded-md tw:border tw:border-transparent tw:px-3 tw:py-1 tw:text-sm tw:font-medium tw:text-muted-foreground tw:transition-[color,box-shadow] tw:focus-visible:border-ring tw:focus-visible:outline-1 tw:focus-visible:outline-ring tw:focus-visible:ring-[3px] tw:focus-visible:ring-ring/50 tw:disabled:pointer-events-none tw:disabled:opacity-50 tw:data-[state=active]:bg-background tw:data-[state=active]:text-foreground tw:data-[state=active]:shadow-sm tw:dark:data-[state=active]:bg-card tw:[&_svg]:pointer-events-none tw:[&_svg]:shrink-0 tw:[&_svg:not([class*=size-])]:size-4",
        className,
      )}
      {...props}
    />
  );
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("tw:flex-1 tw:outline-none", className)}
      {...props}
    />
  );
}

export { Tabs, TabsContent, TabsList, TabsTrigger };
